export const getMultiselectOptionsFromValue = (value, id) => {
  if (!value.length) {
    return [];
  }

  const splittedValueList = value.split(';');

  return splittedValueList.map(value => ({
    id,
    name: value,
  }));
};
